/* Created By CoolGuy on 2017/11/12
 */
import React, { ChangeEvent, useRef, useState } from 'react';
// import { observer, inject } from "mobx-react";
// import { observable, action } from "mobx";
import './PasswordModal.scss';
import intl from 'react-intl-universal';
import { fixIosFocusProblem } from '../../utils/dom';

export interface IPasswordModalProps {
  open: boolean;
  onInputEnd: any;
}

const emptyResultArray = Array(6).fill('');

function PasswordModal(props: IPasswordModalProps) {
  const { open = true, onInputEnd } = props;

  const input = useRef(null);
  const [resultArray, setResultArray] = useState(emptyResultArray);
  const [tip, setTip] = useState('');
  if (!open) {
    return null;
  }
  const loc = intl.getInitOptions().currentLocale;
  //上级因为会处理onTouchEnd，所以如果这里不阻止冒泡会导致onClick事件无法触发
  const inputThePassword = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setResultArray(value.split('').concat(Array(6 - value.length).fill('')));
    setTip('');
    if (value.length === 6) {
      setTimeout(() => {
        setResultArray(emptyResultArray);
      }, 300);

      onInputEnd(value).then((res: boolean) => {
        if (!res) {
          setTip('抱歉，您输入的密码有误！请核对！');
        }
      });
    }
  };
  const focusPasswordInput = () => {
    const { current } = input;
    // @ts-ignore
    current && current.focus();
  };
  return (
    <div
      className="passwordmodal"
      onTouchEnd={e => {
        e.stopPropagation();
      }}
    >
      <div className="main">
        <div className="head">
          <span className="text">
            <span className="back" />
            <span className="real">{intl.get('input-pass')}</span>
          </span>
        </div>
        <input
          autoFocus={true}
          className={'input'}
          maxLength={6}
          ref={input}
          onChange={inputThePassword}
          type="number"
          value={resultArray.join('')}
          onBlur={e => fixIosFocusProblem(e.target)}
        />
        <div className="content">
          {[1, 2, 3, 4, 5, 6].map((one, index) => {
            return (
              <div
                key={index}
                className="input-square"
                onClick={focusPasswordInput}
              >
                {resultArray[index] || ''}
              </div>
            );
          })}
        </div>
        {tip && (
          <div className="tips">
            <img
              src={require('../../assets/info-green.png')}
              className="info"
              alt=""
            />
            <span>{tip}</span>
          </div>
        )}
      </div>
    </div>
  );
}
export default PasswordModal;
